/** @format */

import { RatingDistribution } from './rating-distribution.interface';
import { SecondaryRating } from './secondary-rating.interface';

export interface ReviewSummary {
  averageRating: number;
  overallRatingRange: number;
  ratingDistribution: RatingDistribution[];
  recommendedCount?: number | null;
  reviewCount: number;
  secondaryRatings: SecondaryRating[];
}
